import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css'; // Import Quill styles

import { CustomInput } from '../../styledComponents';

import './style.scss';

import { css } from '@emotion/css';

import { WORD_LIMIT_QUILL } from '../../../utils/constants';

export default function FormGroup({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  name,
  errorText,
  displayAsTextArea = false,
  rightLabelText,
  limit,
  leftLabel,
  disabled,
  rightButtonText = '',
  rightButtonOnClick,
  autoFocus = false,
  required = false,
  showQuillSecondarytext = false,
  disabledColor,
  inputStyles,
  onPaste,
  isError = false,
}) {
  const modules = {
    toolbar: [['bold', 'italic', 'underline', 'link']],
  };

  const quillRef = useRef();
  const [textLength, setTextLength] = useState(0);
  const [isWordLimitError, setIsWordLimitError] = useState(false);

  useEffect(() => {
    if (quillRef.current?.unprivilegedEditor) {
      const unprivilegedEditor = quillRef.current.unprivilegedEditor;
      const length = unprivilegedEditor.getText().length - 1;
      setTextLength(length);
      setIsWordLimitError(length > WORD_LIMIT_QUILL);
    }
  }, [value]);

  const handleChange = (content, delta, source, editor) => {
    const length = editor.getText().length - 1;

    if (length <= WORD_LIMIT_QUILL) {
      onChange(content);
      setTextLength(length);
      setIsWordLimitError(false);
    } else {
      setIsWordLimitError(true);
    }
  };

  return (
    <div className="formGroup">
      <label htmlFor={id}>
        <span>
          {label}
          {required && <span style={{ color: 'red' }}> *</span>}
        </span>
        {rightLabelText && <span>{rightLabelText}</span>}
        {limit && (
          <span
            style={{
              color: (isError || isWordLimitError) && 'red',
            }}>
            {textLength} / {limit} Char.
          </span>
        )}
      </label>
      <div className="formGroupInput" style={{ border: isError && '1px solid red' }}>
        {leftLabel && <span className="leftLabel">{leftLabel}</span>}
        {showQuillSecondarytext ? (
          <div className="quill-container">
            <ReactQuill
              value={value}
              onChange={handleChange}
              modules={modules}
              placeholder={placeholder}
              theme="snow"
              ref={quillRef}
              className={css`
                .ql-container.ql-disabled .ql-tooltip {
                  visibility: visible;
                }
                input {
                  border: ${isError && '1px solid red'};
                }
                input:focus {
                  border: ${isError && '1px solid red'}!important;
                  outline: ${isError && '1px solid red'}!important;
                }
              `}
            />
          </div>
        ) : displayAsTextArea ? (
          <CustomInput
            as="textarea"
            height={200}
            id={id}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoFocus={autoFocus}
            required={required}
          />
        ) : (
          <CustomInput
            onPaste={onPaste}
            id={id}
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            style={{ width: '100%', ...inputStyles }}
            autoFocus={autoFocus}
            required={required}
            disabledColor={disabledColor}
          />
        )}
        {rightButtonText && <button onClick={rightButtonOnClick}>{rightButtonText}</button>}
      </div>
      {isWordLimitError && <div className="error-message">Word limit reached</div>}
      <p style={{ color: 'var(--red)', textAlign: 'left', fontSize: 13, lineHeight: 1.4 }}>{errorText}</p>
    </div>
  );
}
